const typography = {
  fontFamily: "inter,sans-serif",
  button: {
    textTransform: "none"
  },
  overline: {
    fontWeight: 500,
    fontSize: 11,
    lineHeight: "29px",
    textTransform: "uppercase",
    fontFamily: "inter,sans-serif"
  },
  chip: {
    fontWeight: 500,
    fontSize: 12,
    lineHeight: "18px",
    fontFamily: "inter,sans-serif"
  },
  caption: {
    fontWeight: 400,
    fontSize: 12,
    lineHeight: "18px",
    fontFamily: "inter,sans-serif"
  },
  body2: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: "20px",
    fontFamily: "inter,sans-serif"
  },
  body1: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: "24px",
    fontFamily: "inter,sans-serif"
  },
  subtitle2: {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: "22px",
    fontFamily: "inter,sans-serif"
  },
  subtitle1: {
    fontWeight: 500,
    fontSize: 16,
    lineHeight: "20px",
    fontFamily: "inter,sans-serif"
  },
  h7: {
    fontWeight: 500,
    fontSize: 18,
    lineHeight: "24px",
    fontFamily: "inter,sans-serif"
  },
  h6: {
    fontWeight: 500,
    fontSize: 20,
    lineHeight: "32px",
    fontFamily: "inter,sans-serif"
  },
  h5: {
    fontWeight: 500,
    fontSize: 24,
    lineHeight: "32px",
    fontFamily: "inter,sans-serif"
  },
  h4: {
    fontWeight: 500,
    fontSize: 28,
    lineHeight: "34px",
    fontFamily: "inter,sans-serif"
  },
  h3: {
    fontWeight: 500,
    fontSize: 48,
    lineHeight: "56px",
    fontFamily: "inter,sans-serif"
  },
  h2: {
    fontWeight: 500,
    fontSize: 60,
    lineHeight: "72px",
    fontFamily: "inter,sans-serif"
  },
  h1: {
    fontWeight: 500,
    fontSize: 72,
    lineHeight: "86px",
    fontFamily: "inter,sans-serif"
  },
  buttonLarge: {
    fontSize: 16,
    lineHeight: "24px",
    fontWeight: 500,
    fontFamily: "inter,sans-serif"
  },
  buttonMedium: {
    fontSize: 14,
    lineHeight: "20px",
    fontWeight: 500,
    fontFamily: "inter,sans-serif"
  },
  buttonSmall: {
    fontSize: 12,
    lineHeight: "16px",
    fontWeight: 500,
    fontFamily: "inter,sans-serif"
  },
  tableHeader1: {
    fontSize: 14,
    lineHeight: "24px",
    fontWeight: 600,
    fontFamily: "inter,sans-serif"
  },
  tableHeader2: {
    fontSize: 13,
    lineHeight: "24px",
    fontWeight: 500,
    fontFamily: "inter,sans-serif"
  },
  avatarLetter: {
    fontSize: 20,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "inter,sans-serif"
  },
  inputLabel: {
    fontSize: 12,
    lineHeight: "12px",
    fontWeight: 400,
    fontFamily: "inter,sans-serif"
  },
  inputText1: {
    fontSize: 16,
    lineHeight: "24px",
    fontWeight: 400,
    fontFamily: "inter,sans-serif"
  },
  inputText2: {
    fontSize: 13,
    lineHeight: "16px",
    fontWeight: 400,
    fontFamily: "inter,sans-serif"
  },
  helperText: {
    fontSize: 12,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "inter,sans-serif"
  },
  tooltip: {
    fontSize: 11,
    lineHeight: "14px",
    fontWeight: 500,
    fontFamily: "inter,sans-serif"
  },
  // marketing
  marketingSerifSmall: {
    fontSize: 18,
    lineHeight: "24px",
    fontWeight: 900,
    fontFamily: "Source Serif Pro",
    fontStyle: "italic"
  },
  marketingSerifLarge: {
    fontSize: 26,
    lineHeight: "32px",
    fontWeight: 900,
    fontFamily: "Source Serif Pro",
    fontStyle: "italic"
  },
  marketingSansSerifSmall: {
    fontSize: 24,
    lineHeight: "32px",
    fontWeight: 600,
    fontFamily: "Beausite Classic"
  },
  marketingSansSerifLarge: {
    fontSize: 30,
    lineHeight: "36px",
    fontWeight: 600,
    fontFamily: "inter,sans-serif"
  }
};

export default typography;
